export const getIsIos = () => {
	if (typeof window === 'undefined') return false;

	const ua = window.navigator?.userAgent || '';

	const isiDevice = /iPad|iPhone/i.test(ua);

	// Detect iPad OS 13+ fallback (MacIntel with touch support)
	const isiPad13Plus =
		navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;

	return isiDevice || isiPad13Plus;
};

export const getIsIosSafari = () => {
	if (typeof window === 'undefined') return false;

	const ua = window.navigator?.userAgent || '';

	const iOS = getIsIos();
	const webkit = !!ua.match(/WebKit/i);

	return iOS && webkit && !ua.match(/CriOS|Chrome|FxiOS|EdgiOS/i);
};

export const getIsAndroidWebView = () => {
	if (typeof window === 'undefined') return false;

	const ua = window.navigator?.userAgent || '';
	const android = !!ua.match(/Android/i);
	const webview = !!ua.match(/wv/i);
	return android && webview;
};

/**
 * Returns true if user's primary input is capable of hover.
 * Can be useful when you need to discern between mouse and touch devices.
 */
export const getIsMediaHover = () => {
	try {
		return matchMedia('(hover: hover)').matches;
	} catch {
		// Assume if browser too old to support `matchMedia` it's likely not a touch device.
		return true;
	}
};

export const isWindowDefined = () => typeof window !== 'undefined';

export const openUrl = (url: string, opts?: { append?: boolean }) =>
	window.open(opts?.append ? `${window.location.href}${url}` : url, '_blank');

export const copyToClipboard = (stringToCopy: string) => {
	navigator.clipboard.writeText(stringToCopy);
};
